import { createFileRoute } from '@tanstack/react-router'

import { WaitlistListPage } from '#features/admin/waitlist/waitlist-list-page'

export const Route = createFileRoute('/_app/admin/waitlist')({
  component: WaitlistListPage,
})
